import { combineReducers } from 'redux';
import update from './update';
import * as fromUpdate from './update';
import fetch from './fetch';
import * as fromFetch from './fetch';

export default combineReducers({
  update,
  fetch,
});

export const getUpdatingGroup = (state) => fromUpdate.getGroup(state.update);

export const isUpdatingGroup = (state) => fromUpdate.isUpdating(state.update);

export const getGroups = (state) => fromFetch.getGroups(state.fetch);

export const isFetchingGroups = (state) => fromFetch.isFetching(state.fetch);
